const defaultState = {
  adsModalDisplay: false,
  currentAdsListing : {},
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_ADS_MODAL_DISPLAY':
      return {
        ...state,
        adsModalDisplay: action.adsModalDisplay,
      }
      case 'SET_CURRENT_ADS_LISTING':
      return {
        ...state,
        currentAdsListing: action.currentAdsListing,
      }
    default:
      return state;
  };
};